import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
export var HighlightText = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HighlightText, _React$PureComponent);

  var _super = _createSuper(HighlightText);

  function HighlightText() {
    _classCallCheck(this, HighlightText);

    return _super.apply(this, arguments);
  }

  _createClass(HighlightText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          highlights = _this$props.highlights;
      var parts = [];
      var lastIndex = 0;

      if (highlights) {
        highlights.sort(function (a, b) {
          return a.start - b.start;
        }).reduce(function (highlights, highlight) {
          var lastHighlight = highlights[highlights.length - 1];

          if (!lastHighlight || highlight.start > lastHighlight.end + 1) {
            return highlights.concat(highlight);
          }

          if (highlight.end > lastHighlight.end) {
            lastHighlight.end = highlight.end;
          }

          return highlights;
        }, []).forEach(function (highlight) {
          var start = highlight.start,
              end = highlight.end;

          if (start >= end) {
            return;
          }

          if (start > lastIndex) {
            parts.push({
              value: children.substring(lastIndex, start),
              matches: false
            });
          }

          parts.push({
            value: children.substring(start, end + 1),
            matches: true
          });
          lastIndex = end + 1;
        });
      }

      if (lastIndex < children.length) {
        parts.push({
          value: children.substring(lastIndex, children.length),
          matches: false
        });
      }

      return parts.map(function (part, index) {
        if (part.matches) {
          return /*#__PURE__*/React.createElement("b", {
            key: index
          }, part.value);
        }

        return part.value;
      });
    }
  }]);

  return HighlightText;
}(React.PureComponent);